import React from 'react'
import { ThemeProvider } from 'styled-components'

import './App.css'
import theme from './theme'
import { Header, HomePage, Footer } from './components/'


class App extends React.Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <div className="App">
          <Header />
          <HomePage />
          <Footer />
        </div>
      </ThemeProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js